import type { ComponentType } from 'react';

import type { ModalPropsMap, ModalType, ModalUIProps } from '@shared/lib/modal';

export type ModalComponentProps<T extends ModalType> = ModalUIProps<ModalPropsMap[T]>;

type ModalComponentRegistry = { [T in ModalType]: ComponentType<ModalComponentProps<T>> };

export const modalComponentRegistry: ModalComponentRegistry = {};
